<template>
  <div>
    <Breadcrumb main-name="标签管理" :breadcrumbList="breadcrumbList">
    </Breadcrumb>
    <div class="page-container">
      <div class="page-container__left">
        <a-button
          style="padding: 0 8px; margin-bottom: 16px; width: unset; margin-left: 24px;"
          @click="handleTagOfGroup('addTagGroup')"
          >新增标签组</a-button
        >
        <a-menu
          style="width: 196px; height: calc(100% - 62px); min-height: 180px;"
          mode="inline"
          theme="light"
          :default-selected-keys="[0]"
        >
          <a-menu-item
            v-for="(item, index) in tagGroupArr"
            :key="index"
            @click="handleItemClick(item, index)"
          >
            <div v-if="item.editGroupNameFlag === true" class="tag-group-item">
              <a-input
                class="item-name-input"
                :maxLength="60"
                :defaultValue="item.name"
                v-model="item.tempName"
                @pressEnter="updateGroupName(item)"
              ></a-input>
              <div>
                <span class="item-save" @click="updateGroupName(item)"
                  >保存</span
                >
                <span class="item-cancel" @click="cancelEditGroupName(item)"
                  >取消</span
                >
              </div>
            </div>
            <div
              v-else
              class="tag-group-item"
              @mouseenter="handleOperateIcon(item, true)"
              @mouseleave="handleOperateIcon(item, false)"
            >
              <span class="item-group-name">{{ item.name || "--" }}</span>
              <div v-show="item.iconShow">
                <a-icon
                  class="item-icon-edit"
                  type="edit"
                  @click.stop="editTagGroupName(item)"
                />
                <a-icon
                  class="item-icon-delete"
                  type="delete"
                  @click.stop="deleteTagGroup(item)"
                />
              </div>
            </div>
          </a-menu-item>
        </a-menu>
      </div>
      <div class="page-container__right">
        <a-row type="flex" justify="space-between" align="middle">
          <span class="tag-group-name">{{
            (currentTagGroup || {}).name || ""
          }}</span>
          <div>
            <a-button type="primary" @click="handleTagOfGroup('addTag')">
              新 增
            </a-button>
            <a-button
              :style="{ marginLeft: '8px' }"
              @click="visibleImportModal = true"
            >
              导 入
            </a-button>
          </div>
        </a-row>
        <div class="tag-list">
          <a-table
            rowKey="id"
            :columns="tagListColumns"
            :dataSource="currentTagGroup.tagArr || []"
            :pagination="{
              pageSizeOptions: pageSizeOptions,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: total => `共${total}条 `
            }"
            :scroll="{ x: 600 }"
            :row-selection="rowSelection"
            :loading="tagListLoading"
          >
            <div
              slot="filterDropdown"
              slot-scope="{
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
                column
              }"
              style="padding: 8px"
            >
              <a-input
                v-ant-ref="c => (searchInput = c)"
                :placeholder="`搜索${column.title}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="
                  e => setSelectedKeys(e.target.value ? [e.target.value] : [])
                "
                @pressEnter="
                  () => handleSearch(selectedKeys, confirm, column.dataIndex)
                "
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="
                  () => handleSearch(selectedKeys, confirm, column.dataIndex)
                "
              >
                搜 索
              </a-button>
              <a-button
                class="tagListSearchResetBtn"
                size="small"
                style="width: 90px"
                @click="() => handleReset(clearFilters)"
              >
                重 置
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template
              slot="customRender"
              slot-scope="text, record, index, column"
            >
              <span v-if="searchText && searchedColumn === column.dataIndex">
                <template
                  v-for="(fragment, i) in text
                    .toString()
                    .split(
                      new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                    )"
                >
                  <mark
                    v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                    :key="i"
                    class="highlight"
                    >{{ fragment }}</mark
                  >
                  <template v-else>{{ fragment }}</template>
                </template>
              </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
            <template slot="tagStatus" slot-scope="row">
              <!--0: 正常 -1: 禁用-->
              <a-switch
                :checked="row.status === 0"
                @change="checked => onTagStatusChange(row, checked)"
              />
            </template>
            <template slot="pointCountSlot" slot-scope="row">
              <span
                class="action-text"
                @click="handleTagOfGroup('showPointsToTagModal', row)"
                >{{ row.pointCount >= 0 ? row.pointCount : "--" }}</span
              >
            </template>
            <template slot="action" slot-scope="row">
              <span
                class="action-text"
                @click="handleTagOfGroup('updateTagName', row)"
                >编辑</span
              >
              <a-popconfirm
                title="你确定要删除该标签吗？"
                ok-text="确 定"
                cancel-text="取 消"
                @confirm="deleteTag([row.id])"
              >
                <span class="action-text">删除</span>
              </a-popconfirm>
            </template>
          </a-table>
          <div
            v-if="(currentTagGroup.tagArr || []).length"
            class="table-bottom-wrap"
          >
            <a-dropdown>
              <a-menu slot="overlay" @click="handleBatchOperate">
                <a-menu-item key="updateBelongGroup">
                  更改标签组
                </a-menu-item>
                <a-menu-item key="batUpdateTagStatus">
                  更改状态
                </a-menu-item>
                <a-menu-item key="batDeleteTags">
                  删除
                </a-menu-item>
              </a-menu>
              <a-button style="width: unset; margin-left: 4px; padding: 0 8px;">
                批量操作 <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </div>
        </div>
      </div>
    </div>
    <Form-Dialog
      :visibleModal.sync="visibleFormModal"
      :formConfig="currentFormConfig"
    ></Form-Dialog>
    <!--标签所属点位弹框-->
    <PointsToTag
      :visibleModal.sync="visiblePointsToTagModal"
      :modalId="currentTagOfTable.id"
      @reloadTags="reloadTags"
    ></PointsToTag>
    <ExcelImport
      title="标签导入"
      :visible-modal.sync="visibleImportModal"
      :fileLength="1"
      :templateFileInfo="{
        fileUrl: `${baseURL}/importTemplate/QFAD-点位标签导入模板.xlsx`,
        desc: 'QFAD标签导入模板'
      }"
      :requestConfig="{
        url: '/tag/importGroupTags',
        params: { tagGroupId: currentTagGroup.id }
      }"
      @successCallback="reloadTags"
    ></ExcelImport>
  </div>
</template>

<script>
import tableMinix from "./tableMinix";
import Breadcrumb from "../common/Breadcrumb.vue";
import FormDialog from "./common/formDialog.vue";
import PointsToTag from "./pointsToTag.vue";
import ExcelImport from "./common/excelImport.vue";
import api from "../../commomFun/api.js";
import { baseURL } from "../../utils/config";
import $ from "jquery";

export default {
  name: "tags",
  components: {
    Breadcrumb,
    FormDialog,
    PointsToTag,
    ExcelImport
  },
  mixins: [tableMinix],
  mounted() {
    this.getTagGroup();
  },
  data() {
    return {
      breadcrumbList: [
        {
          name: "标签管理",
          path: "/tags"
        }
      ],
      baseURL,
      // 导入标签弹框
      visibleImportModal: false,
      // 标签所属点位弹框
      visiblePointsToTagModal: false,
      // 确认框显示
      visibleFormModal: false,
      currentFormConfig: {
        title: "",
        handleConfirm: formDialogInstance => {
          formDialogInstance.$emit("update:visibleModal", false);
        },
        handleCancel: formDialogInstance => {
          formDialogInstance.$emit("update:visibleModal", false);
        },
        handleAfterClose: () => {}
      },
      tagGroupArr: [],
      currentTagGroup: {},
      tagListLoading: false
    };
  },
  methods: {
    // 点击左侧标签组菜单
    handleItemClick(tagGroupItem) {
      if (tagGroupItem.id === this.currentTagGroup.id) return;
      // 切换标签组时重置筛选项
      $(".tagListSearchResetBtn").trigger("click");
      this.currentTagGroup = tagGroupItem;
      this.reloadTags();
    },
    // 重新加载当前标签组内标签
    async reloadTags() {
      this.currentTagGroup.tagArr = await this.getTagsOfCurrentTagGroup({
        parentId: this.currentTagGroup.id
      });
    },
    // 获取标签组内标签列表
    getTagsOfCurrentTagGroup(params) {
      this.selectedRowKeys = [];
      return new Promise(resolve => {
        this.tagListLoading = true;
        api
          .getApi("/tags", { ...params, pageSize: 100000, pageNum: 1 })
          .then(res => {
            if (res.data.code === 200 && res.data.data) {
              resolve(res.data.data.list || []);
            } else {
              resolve([]);
              this.$message.warning(res.data.msg || "获取标签列表失败！");
            }
          })
          .catch(() => {
            resolve([]);
          })
          .finally(() => {
            this.tagListLoading = false;
          });
      });
    },
    // 新增标签组
    addTagGroup(params) {
      return new Promise(resolve => {
        api.postApi("/tagGroup", params).then(res => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg || "新增标签组成功！");
            this.getTagGroup();
            resolve(true);
          } else {
            this.$message.warning(res.data.msg || "新增标签组失败！");
            resolve(false);
          }
        });
      });
    },
    // 获取标签组列表
    getTagGroup() {
      api.getApi("/tagGroup").then(async res => {
        if (res.data.code === 200 && Array.isArray(res.data.data)) {
          this.tagGroupArr = res.data.data || [];
          if (Array.isArray(this.tagGroupArr) && this.tagGroupArr.length) {
            this.currentTagGroup = this.tagGroupArr[0];
            this.currentTagGroup.tagArr = await this.getTagsOfCurrentTagGroup({
              parentId: this.currentTagGroup.id
            });
          }
        } else {
          this.$message.warning(res.data.msg || "标签组获取失败！");
        }
      });
    },
    // 标签组进入编辑状态
    handleOperateIcon(tagGroupItem, showFlag) {
      tagGroupItem.iconShow = showFlag;
      this.$forceUpdate();
    },
    // 编辑标签组名称
    editTagGroupName(tagGroupItem) {
      tagGroupItem.iconShow = false;
      tagGroupItem.editGroupNameFlag = true;
      tagGroupItem.tempName = tagGroupItem.name;
      this.$forceUpdate();
    },
    // 更新标签组名称
    updateGroupName(tagGroupItem) {
      if (
        tagGroupItem.tempName === "" ||
        tagGroupItem.tempName === undefined ||
        tagGroupItem.tempName === null
      ) {
        this.$message.warning("请输入标签组名称！");
        return;
      } else if (tagGroupItem.tempName == tagGroupItem.name) {
        this.$message.warning("标签组名称未改变！");
        return;
      }
      api
        .putApi(`/tagGroup/${tagGroupItem.id}`, { name: tagGroupItem.tempName })
        .then(async res => {
          if (res.data.code === 200) {
            tagGroupItem.iconShow = true;
            tagGroupItem.editGroupNameFlag = false;
            tagGroupItem.name = tagGroupItem.tempName;
            this.$message.success(res.data.msg || "编辑标签组成功！");
          } else {
            this.$message.warning(res.data.msg || "编辑标签组失败！");
          }
        });
    },
    // 取消编辑标签组名称
    cancelEditGroupName(tagGroupItem) {
      tagGroupItem.iconShow = true;
      tagGroupItem.editGroupNameFlag = false;
      this.$forceUpdate();
    },
    // 删除标签组
    deleteTagGroup(tagGroupItem) {
      let _this = this;
      this.$confirm({
        title: "确认删除该标签组吗?",
        content: "删除该标签组后，所属的标签也将一并删除",
        okText: "确 定",
        cancelText: "取 消",
        onOk() {
          api.deleteApi(`/tagGroup/${tagGroupItem.id}`).then(res => {
            if (res.data.code === 200) {
              _this.$message.success(res.data.msg || "删除标签组成功！");
              _this.currentTagGroup.tagArr = [];
              _this.getTagGroup();
            } else {
              _this.$message.warning(res.data.msg || "删除标签组失败！");
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  display: flex;
  flex-direction: row;
  margin: 24px;
  padding: 24px 24px 24px 0;
  background: #ffffff;
  border-radius: 2px;
}
.tag-group-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  .item-group-name {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-name-input {
    margin-right: 12px;
  }
  .item-cancel {
    margin-left: 8px;
  }
  .item-icon-edit {
    margin-left: 10px;
  }
  .item-icon-delete {
    margin-right: 0px;
  }
}
.page-container__left {
  margin-right: 24px;
}
.page-container__right {
  flex: 1;
}
.tag-group-name {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 32px;
}
.tag-list {
  position: relative;
  margin-top: 16px;
  .action-text {
    height: 21px;
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
    color: #1890ff;
    cursor: pointer;
    font-family: PingFangSC-Regular, PingFang SC;
    + .action-text {
      margin-left: 8px;
    }
  }
}
.table-bottom-wrap {
  position: absolute;
  bottom: 16px;
  left: 0;
}
</style>
